export default __webpack_public_path__ + "static/media/inline2.3b9be949.jpg";